import React, { createContext, useContext, useState } from 'react';

type AreaState = {
  activeTab: string;
  uploadedImages: string[];
};

type TabContextType = {
  areaStates: Record<string, AreaState>;
  setActiveTab: (areaName: string, tab: string) => void;
  addUploadedImage: (areaName: string, image: string) => void;
};

const TabContext = createContext<TabContextType | undefined>(undefined);

export const TabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [areaStates, setAreaStates] = useState<Record<string, AreaState>>({});

  const setActiveTab = (areaName: string, tab: string) => {
    setAreaStates((prev) => ({
      ...prev,
      [areaName]: {
        ...(prev[areaName] || { activeTab: 'GRAPHICS', uploadedImages: [] }),
        activeTab: tab,
      },
    }));
  };

  const addUploadedImage = (areaName: string, image: string) => {
    setAreaStates((prev) => ({
      ...prev,
      [areaName]: {
        ...(prev[areaName] || { activeTab: 'GRAPHICS', uploadedImages: [] }),
        uploadedImages: [...(prev[areaName]?.uploadedImages || []), image],
      },
    }));
  };

  return (
    <TabContext.Provider value={{ areaStates, setActiveTab, addUploadedImage }}>
      {children}
    </TabContext.Provider>
  );
};

export const useTabContext = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabContext must be used inside TabProvider');
  }
  return context;
};
